import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./Menu.scss";
import { CategoryMenu } from "./Category/Category";
import { SubCategoryMenu } from "./SubCategory/Subcategory";
import { Font } from "../Fonts/Font";
import { MultiSelect } from "react-multi-select-component";
import ReactFlagsSelect from "react-flags-select";
import { ROUTES } from "../../../data";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { userActions } from "../../../redux/action/userAction";
import { useTranslation } from "react-i18next";

const customValueRenderer = (selected, _options, t) => {
  if (selected.length === 1) {
    return selected[0].label;
  } else if (selected.length > 1) {
    return selected.length + " " + (t ? t("menu.countriesSelected") : "Countries Selected");
  } else {
    return t ? t("menu.noCountrySelected") : "No Country Selected";
  }
};
const DefaultItemRenderer = ({ checked, option, onClick, disabled }) => (
  <div className={`item-renderer ${disabled && "disabled"}`}>
    <input
      type="checkbox"
      onChange={onClick}
      checked={checked}
      tabIndex={-1}
      disabled={disabled}
    />
    <i className={"flag-icon flag-icon-" + option.icon}></i>
    <span style={{ marginLeft: 3 }}>{option.label}</span>
  </div>
);
export const Menu = ({ menuData, ...props }) => {
  const { t } = useTranslation();
  const user = useSelector((el) => el?.authentication?.user);

  const options = [
    { label: "United Kingdom", value: "Uk", icon: "gb" },
    { label: "United States", value: "Eng", icon: "us" },
    { label: "Mali", value: "mal", icon: "ml" },
    { label: "Nigeria", value: "NIG", icon: "ng" },
    { label: "India", value: "In", icon: "in" },
    { label: "France", value: "FR", icon: "fr" },
  ];
  const [selected, setSelected] = useState([]);
  const [country, setCountry] = useState("");

  useEffect(() => {
    const getGeoInfo = () => {
      axios
        .get("https://api.country.is/")
        .then((response) => {
          let data = response.data;
          const detectedCode = data.country.toLowerCase();
          const matched = options.find((o) => o.icon === detectedCode);
          if (matched) {
            setSelected([matched]);
          }
          setCountry(data.country);
        })
        .catch((error) => {
          // geo info fetch failed
        });
    };
    getGeoInfo();
  }, [user]);

  const handleCountrySelect = (newSelected) => {
    if (newSelected.length === 0) {
      setSelected([]);
    } else {
      // Single-select: keep only the last (newly added) item
      const newItem = newSelected.filter(
        (item) => !selected.some((s) => s.value === item.value)
      );
      setSelected(newItem.length > 0 ? [newItem[newItem.length - 1]] : [newSelected[newSelected.length - 1]]);
    }
  };
  const [subCategory, setSubCategory] = useState([]);
  const [category, setCategory] = useState(false);
  const showCategory = () => {
    setCategory(true);
  };
  const hideCategory = () => {
    setCategory(false);
  };
  const setSubData = (data) => {
    setSubCategory(data);
  };
  const dispatch = useDispatch();
  const MenuA = useSelector((el) => el?.productMeta?.data?.categories);
  let catergoryMenu = MenuA?.filter((el) => el.parent === -1);
  let tokenData = user?.jwt_token?.split(".")[1];
  let isSellerVerified;
  if (tokenData) {
    isSellerVerified = JSON.parse(atob(tokenData));
  }

  const isAuth = !!isSellerVerified?.seller_verified;

  const isLoggedIn = !!user?.jwt_token;
  const isSeller = user?.user_type === 'Both' || user?.user_type === 'Seller' || user?.user_type === 'Admin';

  useEffect(() => {
    if (isLoggedIn && isSeller) {
      dispatch(userActions.getProductData());
    }
  }, [dispatch, isLoggedIn, isSeller]);
  return (
    <div className={["es-custom-menu"].join(" ")}>
      <div className="es-custom-menu-row">
        <div onMouseOver={showCategory} onMouseOut={hideCategory}>
          <Font
            size={16}
            weight={500}
            clickable={true}
            color="#fff"
            label={t("header.categories")}
          />
          <img src={""} alt="" />
        </div>

        <div className="menu-options">
          <Font
            size={16}
            weight={500}
            clickable={true}
            color="#fff"
            label={t("header.newManufacturing")}
            link={ROUTES.MANUFACTURING}
          />
          <Font
            size={16}
            weight={500}
            clickable={true}
            link={ROUTES.ECO_FRIENDLY}
            color="#fff"
            label={t("header.ecoFriendly")}
          />
          <Font
            size={16}
            weight={500}
            clickable={true}
            color="#fff"
            link={ROUTES.SPONSORSHIP}
            label={t("header.endlessSponsorship")}
          />
          {isAuth ? (
            ""
          ) : (
            <Font
              size={16}
              weight={500}
              clickable={true}
              color="#fff"
              link={ROUTES.REGISTER + "?type=seller"}
              label={t("header.becomeASeller")}
            />
          )}
          <div className=" seller">
            <Font size={16} label={t("Shipping to") + ":"} color={"#fff"} />
            {/* <ReactFlagsSelect
              selected={country}
              onSelect={(code) => setCountry(code)}
              searchable
            /> */}
            <MultiSelect
              options={options}
              ItemRenderer={DefaultItemRenderer}
              valueRenderer={customValueRenderer}
              value={selected}
              onChange={handleCountrySelect}
              labelledBy="Seac"
              shouldToggleOnHover
              overrideStrings={{ search: t("menu.searchByCountry") }}
            />
          </div>
        </div>
      </div>

      <div
        onMouseOver={showCategory}
        onMouseOut={hideCategory}
        style={{ position: "absolute", display: category ? "flex" : "none" }}
      >
        <CategoryMenu
          onHover={(data) => {
            setSubData(data);
          }}
          menu={catergoryMenu}
        />
        {subCategory?.length > 0 && (
          <SubCategoryMenu parent={catergoryMenu} menu={subCategory} />
        )}
      </div>
    </div>
  );
};

Menu.propTypes = {
  menuData: PropTypes.array.isRequired,
  subMenuData: PropTypes.array.isRequired,
};

Menu.defaultProps = {
  menuData: [],
  subMenuData: [],
};
